<template>
  <div class="edit-video-box">
    <el-dialog :title="'视频编辑'" :visible.sync="dialogVisible" width="480px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="editParam" :rules="rules" label-position="left" label-width="180px">
        <div class="form-flex-box">
          <el-form-item label="总榜排序值:">
            <el-input v-model.number="editParam.indexSort" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="每日热播排序值:">
            <el-input v-model.number="editParam.hotSort" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="虚假浏览数(真+假):">
            <el-input v-model.number="editParam.fakeCountBrowse" size="small"></el-input>
          </el-form-item>
        </div>
        <!-- <div class="form-flex-box">
          <el-form-item label="当日虚假浏览数(真+假):">
            <el-input v-model.number="editParam.countBrowseCurDay" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="当周虚假浏览数(真+假):">
            <el-input v-model.number="editParam.countBrowseCurWek" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="当月虚假浏览数(真+假):">
            <el-input v-model.number="editParam.countBrowseCurMon" size="small"></el-input>
          </el-form-item>
        </div> -->
        <div class="form-flex-box">
          <el-form-item label="海报链接:">
            <el-input v-model="editParam.poster" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="移动端海报链接:">
            <el-input v-model="editParam.posterMobile" size="small"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitDate()" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      flag: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      tagList: [], //标签列表：包含标签名称和标签id
      tag: [],
      editTitle: true,
      editParam: {
        id: "",
        indexSort: "",
        poster: "",
        fakeCountBrowse: "",
        hotSort: "",
        // countBrowseCurDay: "",
        // countBrowseCurWek: "",
        // countBrowseCurMon: "",
      },
      updateTypes: [
        { label: "默认", value: 0 },
        { label: "更新中", value: 1 },
        { label: "已完结", value: 2 },
      ],
      // 表单验证规则
      rules: {
        cover: [
          { required: true, message: "请输入添加封面图片", trigger: "blur" },
        ],
        tags: [{ required: true, message: "请选择标签", trigger: "blur" }],
      },
      dimensions: [],
      dimension: "",
      kinds: [
        { label: "动漫", value: 0 },
        { label: "漫画", value: 1 },
        { label: "COS", value: 2 },
        { label: "真人", value: 3 },
        { label: "小说", value: 4 },
        { label: "写真", value: 5 },
        { label: "原作", value: 6 },
      ],
      isTagSelector: false
    };
  },
  methods: {
    changeUpdateSta() {
      if (this.editParam.updateStatus == 1) {
        this.editParam.updatedDesc = "更新至X话"
      } else if (this.editParam.updateStatus == 2) {
        this.editParam.updatedDesc = "已完结X话"
      } else {
        this.editParam.updatedDesc = undefined
      }
    },
    getTagList() {
      this.tagList = [];
      if (this.editParam.kind === undefined) {
        this.$message.error("请选择种类");
        return
      }
      const param = {
        "kind": this.editParam.kind,
        "dimension": this.dimension
      }
      API.getMediaTagByKindDimension(param).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data;
        }
      });
    },
    // 提交验证
    submitDate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.editVideo();
        } else {
          this.flag = false;
          return false;
        }
      });
    },
    // 编辑
    editVideo() {
      API.editMediaInfo(this.editParam)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.$emit("handlerVideoList");
          } else {
            this.$message.error("编辑失败！");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 请求种类下的维度列表数据
    getTagDimensionsList() {
      this.tagList = [];
      this.dimension = "";
      if (this.editParam.kind === undefined) {
        this.$message.error("请选择种类");
        return
      }
      API.getMediaTagDimensions({"kind": this.editParam.kind})
        .then(res => {
          if (res.code === 200 && res.data) {
            this.dimensions = res.data;
          } else {
            this.dimensions = [];
          }
        })
        .catch(() => {
          this.dimensions = [];
        });
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true;
      this.isTagSelector = true;
      this.editParam.id = data.id;
      this.editParam.indexSort = data.indexSort;
      this.editParam.hotSort = data.hotSort;
      this.editParam.fakeCountBrowse = data.fakeCountBrowse;
      // this.editParam.countBrowseCurDay = data.countBrowseCurDay;
      // this.editParam.countBrowseCurWek = data.countBrowseCurWek;
      // this.editParam.countBrowseCurMon = data.countBrowseCurMon;
      this.editParam.poster = data.poster;
      // this.getTagDimensionsList();
    },
    // 关闭回掉
    handleClose() {
      this.dialogVisible = false;
      this.editTitle = true;
      this.isTagSelector = false;
      this.$refs.form.resetFields();
    },
    // 封面图上传成功回调
    successCallbackHeng(res) {
      this.editParam.horizontalCover = res.data.coverImg;
    },
    successCallbackShu(res) {
      this.editParam.verticalCover = res.data.coverImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 240px;
  }
  .activity-box {
    /deep/ .el-input {
      width: 500px !important;
    }
  }
  .form-flex-box {                                                                                                                                                                                                                                                                                              
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .updatedDesc {
    /deep/ .el-form-item__content {
      display: flex;
    }
    /deep/ .el-input {
      flex: 1;
    }
  }
}
</style>
